// src/components/pwa/NotificationForegroundListener.jsx
import { useEffect } from 'react';
import { useToast } from '../../context/ToastContext';
import { useOrderUpdates } from '../../context/OrderUpdatesContext';
import { listenForForegroundMessages } from '../../services/NotificationService';

// The service worker's onBackgroundMessage handler only fires while the app
// is backgrounded/closed. When it's open and focused, FCM delivers messages
// here instead, so we surface them as a toast.
const NotificationForegroundListener = () => {
  const { addToast } = useToast();
  const { publishUpdate } = useOrderUpdates();

  useEffect(() => {
    listenForForegroundMessages((payload) => {
      // The backend sends data-only payloads (see utils/pushNotifications.js
      // on the backend), so the message is under payload.data, not
      // payload.notification.
      const { title, body, orderId, status } = payload.data || {};
      addToast([title, body].filter(Boolean).join(' - ') || 'New notification', 'info', 5000);

      // Order status pushes carry orderId/status so pages like OrderHistory
      // can refresh instantly instead of waiting for their next poll.
      if (orderId) {
        publishUpdate({ orderId, status });
      }
    });
  }, [addToast, publishUpdate]);

  return null;
};

export default NotificationForegroundListener;
